var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnitedStates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.128,
    height: 9.911,
    viewBox: "0 0 15.128 9.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f5f5f5;}.b{fill:#ff4b55;}.c{fill:#41479b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -88.276)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.867,98.187H.261A.261.261,0,0,1,0,97.927v-9.39a.261.261,0,0,1,.261-.261H14.867a.261.261,0,0,1,.261.261v9.39A.261.261,0,0,1,14.867,98.187Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 88.276)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.128,88.979H0v-.463a.251.251,0,0,1,.261-.241H14.867a.251.251,0,0,1,.261.241v.463Z",
    transform: "translate(0 -88.276)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 15.128,
    height: 0.703,
    transform: "translate(0 3.069)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 15.128,
    height: 0.703,
    transform: "translate(0 1.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.128,243.8H.261A.251.251,0,0,1,0,243.561V243.1H15.128Z",
    transform: "translate(0 -238.494)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 15.128,
    height: 0.703,
    transform: "translate(0 7.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.867,398.624H.261A.251.251,0,0,1,0,398.384v-.463H15.128v.463A.251.251,0,0,1,14.867,398.624Z",
    transform: "translate(0 -388.713)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 15.128,
    height: 0.703,
    transform: "translate(0 6.139)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.255,88.277H.241A.241.241,0,0,0,0,88.518v4.442a.241.241,0,0,0,.241.241H6.255a.241.241,0,0,0,.241-.241V88.518A.241.241,0,0,0,6.255,88.277Z",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.388 88.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.54,107.984l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,14.54,107.984Z",
    transform: "translate(-14.253 -107.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.54,138.639l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,14.54,138.639Z",
    transform: "translate(-14.253 -137.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.54,169.293l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,14.54,169.293Z",
    transform: "translate(-14.253 -167.607)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.54,199.947l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,14.54,199.947Z",
    transform: "translate(-14.253 -197.426)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.54,230.6l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,14.54,230.6Z",
    transform: "translate(-14.253 -227.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.333,123.014l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,38.333,123.014Z",
    transform: "translate(-37.397 -122.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.333,153.668l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,38.333,153.668Z",
    transform: "translate(-37.397 -152.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.333,184.322l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,38.333,184.322Z",
    transform: "translate(-37.397 -182.226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.333,214.977l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,38.333,214.977Z",
    transform: "translate(-37.397 -212.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.126,107.984l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,62.126,107.984Z",
    transform: "translate(-60.542 -107.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.126,138.639l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,62.126,138.639Z",
    transform: "translate(-60.542 -137.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.126,169.293l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,62.126,169.293Z",
    transform: "translate(-60.542 -167.607)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.126,199.947l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,62.126,199.947Z",
    transform: "translate(-60.542 -197.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.126,230.6l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,62.126,230.6Z",
    transform: "translate(-60.542 -227.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.92,123.014l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,85.92,123.014Z",
    transform: "translate(-83.687 -122.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.92,153.668l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,85.92,153.668Z",
    transform: "translate(-83.687 -152.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.92,184.322l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,85.92,184.322Z",
    transform: "translate(-83.687 -182.226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.92,214.977l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,85.92,214.977Z",
    transform: "translate(-83.687 -212.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.712,107.984l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,109.712,107.984Z",
    transform: "translate(-106.831 -107.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.712,138.639l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,109.712,138.639Z",
    transform: "translate(-106.831 -137.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.712,169.293l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,109.712,169.293Z",
    transform: "translate(-106.831 -167.607)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.712,199.947l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,109.712,199.947Z",
    transform: "translate(-106.831 -197.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.712,230.6l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,109.712,230.6Z",
    transform: "translate(-106.831 -227.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M133.506,123.014l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,133.506,123.014Z",
    transform: "translate(-129.976 -122.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M133.506,153.668l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,133.506,153.668Z",
    transform: "translate(-129.976 -152.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M133.506,184.322l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,133.506,184.322Z",
    transform: "translate(-129.976 -182.226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M133.506,214.977l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,133.506,214.977Z",
    transform: "translate(-129.976 -212.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.3,107.984l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,157.3,107.984Z",
    transform: "translate(-153.122 -107.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.3,138.639l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,157.3,138.639Z",
    transform: "translate(-153.122 -137.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.3,169.293l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,157.3,169.293Z",
    transform: "translate(-153.122 -167.607)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.3,199.947l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,157.3,199.947Z",
    transform: "translate(-153.122 -197.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.3,230.6l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,157.3,230.6Z",
    transform: "translate(-153.122 -227.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M181.093,123.014l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041H181l.053-.16A.023.023,0,0,1,181.093,123.014Z",
    transform: "translate(-176.266 -122.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M181.093,153.668l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041H181l.053-.16A.023.023,0,0,1,181.093,153.668Z",
    transform: "translate(-176.266 -152.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M181.093,184.322l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041H181l.053-.16A.023.023,0,0,1,181.093,184.322Z",
    transform: "translate(-176.266 -182.226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M181.093,214.977l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041H181l.053-.16A.023.023,0,0,1,181.093,214.977Z",
    transform: "translate(-176.266 -212.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M204.887,107.984l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,204.887,107.984Z",
    transform: "translate(-199.412 -107.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M204.887,138.639l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,204.887,138.639Z",
    transform: "translate(-199.412 -137.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M204.887,169.293l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.161a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.161-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,204.887,169.293Z",
    transform: "translate(-199.412 -167.607)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M204.887,199.947l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,204.887,199.947Z",
    transform: "translate(-199.412 -197.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M204.887,230.6l.053.16h.168a.023.023,0,0,1,.013.041l-.135.1.051.16a.023.023,0,0,1-.035.025l-.137-.1-.137.1a.023.023,0,0,1-.035-.025l.051-.16-.135-.1a.023.023,0,0,1,.013-.041h.168l.053-.16A.023.023,0,0,1,204.887,230.6Z",
    transform: "translate(-199.412 -227.243)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStates);
export default __webpack_public_path__ + "static/media/united-states.3ed2eeac.svg";
export { ForwardRef as ReactComponent };